import { useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';

import type { FC } from 'react';
import type { IConfirmationDialogProps } from '@/components/modals/interfaces.ts';

export const ConfirmationDialog: FC<IConfirmationDialogProps> = ({
  description,
  title,
  primaryActionText,
  response,
  children
}) => {
  const [open, setOpen] = useState(false);

  const showDialog = (): void => {
    setOpen(true);
  };

  const hideDialog = (): void => {
    setOpen(false);
  };

  const confirmRequest = (): void => {
    response();
    hideDialog();
  };

  return (
    <>
      {children(showDialog)}
      {open && (
        <Dialog
          open={open}
          onClose={hideDialog}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <ModalContentBody id="confirm-dialog-description">{description}</ModalContentBody>
          </DialogContent>
          <DialogActions>
            <Button onClick={hideDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmRequest} color="primary" variant="contained">
              {primaryActionText}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

const ModalContentBody = styled.div`
  padding-top: 0.5em;
`;
